export const EMPTY_FUNCTION = () => {
  // Intentional empty function to avoid sonarqube code smells
}

export const BREAKPOINTS = {
  XS_MIN_WIDTH: '500px',
  XM_MIN_WIDTH: '768px',
  XM_MAX_WIDTH: '1151px'
}

// Onboarding Director specific
export const SERVICE_ID = 'omig-jwv-device-onboarding'

export const DEVICE_NOT_SUPPORTED = 'notSupported'
export const DEVICE_CDM_ONLY = 'cdmOnly'
export const DEVICE_LEDM_ONLY = 'ledmOnly'
export const DEVICE_LEDM_AND_CDM = 'ledmAndCdm'

export const PLATFORM_IDENTIFIER = {
  GEN_2_YETI: 'gen2Yeti',
  GEN_2: 'gen2',
  GEN_1: 'gen1'
}

export const PROGRAM = {
  INSTANT_INK: 'InstantInk',
  UCDE: 'UCDE',
  UCDE_PLUS: 'UCDEplus',
  WORK_FROM_HOME: 'WFH',
  YETI: 'YETI'
}

export const CACHE_STRATEGY_CACHEFIRST = 'cacheFirst'
export const MAX_AGE_IN_SECONDS = 1800

export const DELAY_2_SEC = 2 * 1000
export const DELAY_5_SEC = 5 * 1000
export const DELAY_2_MIN = 2 * 60 * 1000
export const DELAY_3_MIN = 3 * 60 * 1000

export const RESULT = {
  FAILURE: 'failure',
  SUCCESS: 'success',
  INELIGIBLE: 'ineligible',
  ALREADY_PERFORMED: 'alreadyPerformed'
}

export const DISABLED = 'disabled'

export const ACTIVATION_PHASE = {
  ENABLE_WEB_SERVICES: 1,
  DEVICE_VALIDATION: 2,
  GEN2_DEVICE: 2,
  DEVICE_REGISTRATION: 3,
  RTP_VALIDATION: 4,
  ENABLE_SHORTCUTS: 5
}

// Non-DeviceHttpProxy custom error codes
export const VALIDATE_DEVICE_TIMEOUT_ERROR = 'OM_XXX_VD00002'
export const VALIDATE_RTP_TIMEOUT_ERROR = 'OM_XXX_RS00002'
export const VALIDATE_DEVICE_FALLBACK_ERROR = 'VD00001'
export const REGISTER_DEVICE_FALLBACK_ERROR = 'RD00001'
export const REGISTER_DEVICE_INVALID_DATA_ERROR = 'OM_200_RD00002'
export const REGISTER_GEN2_DEVICE_FALLBACK_ERROR = 'DO00001'
export const REGISTER_GEN2_DEVICE_INVALID_DATA_ERROR = 'OM_200_DO00002'
export const TENANT_INTERFACE_ERROR = 'JS_XXX_TI00001'
export const SYSTEM_CONFIGURATION_FALLBACK_ERROR = 'SC00001'
export const WEB_SERVICES_TIMEOUT_ERROR = 'OM_XXX_EW00001'
export const WEB_SERVICES_DISABLED_BY_ADMIN = 'OM_XXX_EW00002'
export const WEB_SERVICES_REG_HREF_DOES_NOT_EXIST = 'OM_XXX_EW00004'
export const WEB_SERVICES_JET_ADVANTAGE_ENABLED = 'OM_XXX_EW00005'
export const WEB_SERVICES_CONTROL_PANEL_LOCKED = 'OM_XXX_EW00006'
export const RTP_STATUS_FALLBACK_ERROR = 'RS00001'
export const RTP_CONFIG_FALLBACK_ERROR = 'RC00001'
export const SHORTCUT_FALLBACK_ERROR = 'SS00001'
export const SUBSCRIPTION_ENTITY_PATCH_FALLBACK_ERROR = 'SE00001'
export const SUBSCRIPTION_DEACTIVATING_WITHIN_TRIAL_ERROR = 'OM_XXX_SE00002'
export const SUBSCRIPTION_DEACTIVATING_AFTER_TRIAL_ERROR = 'OM_XXX_SE00003'
export const SUBSCRIPTION_SUSPENDED_ERROR = 'OM_XXX_SE00004'
export const SUBSCRIPTION_INACTIVE_WARRANTY_ERROR = 'OM_XXX_SE00005'

// DeviceHttpProxy error code mapping
export const DEFAULT_ERROR_CODE = 'OM_DHP00001'
export const DHP_NON_200_ERROR_CODE = 'OM_DHP00005'

export const DHP_REQUEST_REJECTED_ERROR = 'requestRejected'
export const DHP_DISCOVERY_TREE_EMPTY_ERROR = 'discoveryTreeEmpty'
export const DHP_AVATAR_REGISTRATION_REQUIRED_ERROR =
  'avatarRegistrationRequired'
export const DHP_CLAIM_POSTCARD_REQUIRED_ERROR = 'claimPostcardRequired'
export const DHP_GEN_TWO_MANIFEST_REQUIRED_ERROR =
  'genTwoCloudServiceManifestRequired'
export const DHP_GEN_TWO_MANIFEST_EMPTY_ERROR =
  'genTwoCloudServiceManifestEmpty'
export const DHP_EPRINT_MANIFEST_REQUIRED_ERROR = 'ePrintManifestRequired'
export const DHP_EPRINT_MANIFEST_EMPTY_ERROR = 'ePrintManifestEmpty'
export const DHP_CLAIM_POSTCARD_EMPTY_ERROR = 'claimPostcardEmpty'
export const DHP_FINGERPRINT_EMPTY_ERROR = 'fingerprintEmpty'
export const DEVICE_RESOURCE_PROVIDER_ERROR = 'deviceResourceProviderError'
export const DHP_PLATFORM_IDENTIFIER_INELIGIBLE_ERROR =
  'platformIdentifierIneligible'

export const DHP_ERROR_CODE = {
  invalidArgument: 'OM_DHP00002',
  dataValveError: 'OM_DHP00003',
  unableToDecode: 'OM_DHP00004', // non-DHP error type
  invalidSession: 'HS_DHP00001',
  sessionNotActive: 'HS_DHP00002',
  deviceOffline: 'HS_DHP00003',
  requestRejected: 'HS_DHP00004', // non-DHP error type
  requestTimedOut: 'FW_DHP00001',
  cancelled: 'FW_DHP00002',
  unknownError: 'FW_DHP00003',
  discoveryTreeEmpty: 'FW_DHP00004', // non-DHP error type
  avatarRegistrationRequired: 'FW_DHP00005', // non-DHP error type
  claimPostcardRequired: 'FW_DHP00006', // non-DHP error type
  genTwoCloudServiceManifestRequired: 'FW_DHP00007', // non-DHP error type
  genTwoCloudServiceManifestEmpty: 'FW_DHP00008', // non-DHP error type
  ePrintManifestRequired: 'FW_DHP00009', // non-DHP error type
  ePrintManifestEmpty: 'FW_DHP00010', // non-DHP error type
  claimPostcardEmpty: 'FW_DHP00011', // non-DHP error type
  platformIdentifierIneligible: 'FW_DHP00012', // non-DHP error type
  contentStackEmptyError: 'OM_CS00001', // non-DHP error type
  contentStackLocaleError: 'OM_CS00002', // non-DHP error type
  contentStackCatchAllError: 'OM_CS00003', // non-DHP error type
  deviceResourceProviderError: 'OM_DRP00001' // non-DHP error type
}

// Analytics
const BASE_PATH = '/DeviceOnboarding/'

const ACTIVITY = 'HardwareSetup-v01'

export const ANALYTICS = {
  SCREENS: {
    START: {
      screenName: 'Start',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    ACTIVATION: {
      screenName: 'Activation',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    ACTIVATION_FAILED: {
      screenName: 'ActivationFailed',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    ACTIVATION_SUCCESS: {
      screenName: 'ActivationSuccess',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    }
  },
  CONTROLS: {
    EXIT_SETUP: 'ExitSetupButton',
    RETRY: 'RetryButton',
    CONTINUE_BUTTON: 'ContinueButton',
    ENABLE_WEB_SERVICES: 'EnableWebServices',
    DEVICE_VALIDATION: 'DeviceValidation',
    DEVICE_REGISTRATION: 'DeviceRegistration',
    SUPPORT_BUTON: 'SupportButton',
    RTP_VALIDATION: 'RtpValidation',
    CREATE_SCAN_TO_EMAIL: 'CreateScanToEmail'
  },
  MODES: {
    INTERFACE: {
      [true]: 'Ledm',
      [false]: 'Cdm'
    }
  },
  SUPPORT_LINK: 'SupportLink'
}

// Fallback resource URIs
export const RESOURCE_URI_FALLBACK = {
  CDM: {
    avatarRegistration: '/cdm/cloudServices/v1/avatarRegistration',
    claimPostcard: '/cdm/cloudServices/v1/claim/postcard',
    discoveryTree: '/cdm/servicesDiscovery',
    fingerprint: '/cdm/deviceProvisioning/v1/printerFingerprint',
    internetDiagnostics: '/cdm/network/v1/internetDiagnostics',
    systemIdentity: '/cdm/system/v1/identity'
  },
  LEDM: {
    discoveryTree: '/DevMgmt/DiscoveryTree.xml',
    ePrintManifest: '/ePrint/ePrintManifest.xml',
    ePrintConfigDyn: '/ePrint/ePrintConfigDyn.xml',
    gen2CloudServiceManifest: '/Gen2CloudService/Gen2CloudServiceManifest.xml',
    productConfigDyn: '/DevMgmt/ProductConfigDyn.xml',
    iccManifest: '/Utilities/UtilitiesManifest.xml',
    iccStatus: '/Utilities/ICCStatus',
    iccJob: '/Utilities/ICCJob'
  }
}
export const REGISTER_GEN2_DEVICE_API_RESOURCE_URI_VALUE =
  '/devices/v2/ownerships/swClaim'
export const REGISTER_DEVICE_API_RESOURCE_URI_VALUE = '/$accountId/devices'
export const VALIDATE_DEVICE_API_RESOURCE_URI_VALUE =
  '/$accountId/devices/validate'
export const SYSTEM_CONFIGURATION_API_RESOURCE_URI_VALUE =
  '/$cloudId/system/configuration'
export const RTP_STATUS_API_RESOURCE_URI_VALUE = '/$cloudId/rtpdevicestatus'
export const SUBSCRIPTION_STATE_API_RESOURCE_URI_VALUE =
  '/$subscriptionId/entities/$entityId'

// Monitoring
export const SPAN_FLOW_RESOURCE = 'flow.resource'
export const SPAN_FLOW_PAYLOAD = 'flow.payload'
export const SPAN_MODEL_NAME = 'model.name'
export const SPAN_MODEL_NUMBER = 'model.number'
export const SPAN_WORKFLOW_NAME = 'workflow.name'
export const SPAN_FLOW_RESPONSE = 'flow.response'
export const SPAN_PREFIX_RESULT = '$serviceId-result-'

export const SUPPORT_URL_GENERIC = 'https://support.hp.com'
export const SUPPORT_URL_PRINTER_SETUP = 'https://support.hp.com/printer-setup'
export const SUPPORT_URL_UNABLE_TO_REGISTER =
  'https://support.hp.com/document/ish_4411816-4315131-16?openCLC=true'

export const STATUS_RESULT = {
  SUCCESS: 'success',
  ERROR: 'error'
}

export const ACTIVATION_FAILED_ERRORS = {
  EB000U0422: 'EB000U0422',
  EB000U0405: 'EB000U0405',
  SS00001: 'SS00001'
}

export const BIZ_MODEL = {
  FLEX: 'Flex',
  E2E: 'E2E'
}

export const REGISTRATION_STATE = {
  REGISTERED: 'registered',
  UNREGISTERED: 'unregistered',
  REGISTERING: 'registering',
  NEW_REGISTRATION: 'newRegistration',
  RETRYING: 'retrying',
  CHECK_IN_PROGRESS: 'checkInProgress',
  PROCESSING: 'processing'
}

export const ALLOWED_CONTROL_PANEL_ACCESS = ['open', 'mostlyopen']

// LEDM Payloads
export const EPRINT_REGISTRATION_PAYLOAD =
  '<?xml version="1.0" encoding="UTF-8"?><ep:ePrintConfigDyn xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:dd="http://www.hp.com/schemas/imaging/con/dictionaries/1.0/" xmlns:ep="http://www.hp.com/schemas/imaging/con/eprint/2010/04/30" xsi:schemaLocation="http://www.hp.com/schemas/imaging/con/eprint/2010/04/30 ../../schemas/ePrintConfigDyn.xsd"><ep:RegistrationState>registering</ep:RegistrationState><ep:RegistrationDetails><ep:RegistrationTriggeredBy>software</ep:RegistrationTriggeredBy></ep:RegistrationDetails></ep:ePrintConfigDyn>'

// Launch Darkly
export const FEATURE_FLAG_CLIENT = 'ld-onboarding-migration-client'
export const FEATURE_FLAG_KEYS = {
  enableIcc: 'omig-release-enableicc',
  enableRtpValidation: 'omig-release-rtpvalidation',
  portalBrand: 'omfe-release-portal-brand'
}

export const ICC_STATUS_ALLOWED = {
  connected: 'connected',
  failed: 'failed',
  checkCancelled: 'checkCancelled',
  checkForbidden: 'checkForbidden',
  notApplicable: 'notApplicable'
}

export const ICC_FAILURE_REASON_ALLOWED = {
  networkNotConnected: 'networkNotConnected',
  ipNotRoutable: 'ipNotRoutable',
  gatewayNotConfigured: 'gatewayNotConfigured',
  gatewayNotReachable: 'gatewayNotReachable',
  dnsNotConfigured: 'dnsNotConfigured',
  dnsNotResolved: 'dnsNotResolved',
  dnsNotReachable: 'dnsNotReachable',
  proxyNotConfigured: 'proxyNotConfigured',
  proxyURLResolutionFailed: 'proxyURLResolutionFailed',
  proxyConnectionFailed: 'proxyConnectionFailed',
  proxyRequiresAuthentication: 'proxyRequiresAuthentication',
  proxyCredentialsIncorrect: 'proxyCredentialsIncorrect',
  serverConnectionFailed: 'serverConnectionFailed',
  connected: 'connected',
  notApplicable: 'notApplicable'
}

export const CLOUD_SERVICES_OPTIONS = {
  ENABLED: 'true',
  DISABLED: 'false'
}

export const CDM_DEFAULT_VERSION = '1.0.0'

// Content Stack
export const CONTENT_STACK_EMPTY_ERROR = 'contentStackEmptyError'
export const CONTENT_STACK_LOCALE_ERROR = 'contentStackLocaleError'
export const CONTENT_STACK_CATCH_ALL_ERROR = 'contentStackCatchAllError'

export const ContentStackStacks = {
  api_key: 'blt59b6722a3f241109',
  pie: {
    delivery_token: 'cs47e91bdf5d2a81793f2fa038',
    env_name: 'pie'
  },
  stage: {
    delivery_token: 'cs335df8ff05e826f8181be88c',
    env_name: 'stage'
  },
  prod: {
    delivery_token: 'cs35594ca1f26ad3c1542e75f2',
    env_name: 'prod'
  }
}

export const ContentStackContentTypes = {
  smb_activation: {
    content_type_uid: 'smb_activation_v2'
  },
  consumer_activation: {
    content_type_uid: 'consumer_activation'
  },
  consumer_activation_success: {
    content_type_uid: 'consumer_activation_success'
  },
  hp_allin_activation: {
    content_type_uid: 'hp_allin_paas_flow'
  },
  hp_allin_activation_canceled: {
    content_type_uid: 'activation_failed',
    entry_uid: 'blt88e69f76d58273ab'
  },
  hp_allin_activation_inactive: {
    content_type_uid: 'activation_failed',
    entry_uid: 'bltf447b055ff1435b1'
  },
  hp_allin_activation_overdue: {
    content_type_uid: 'activation_failed',
    entry_uid: 'blte75eac89d4a3b8e3'
  }
}

export const ContentStackPrinterTypes = {
  multi_function: 'MFP',
  single_function: 'SFP'
}

export const ContentStackPrograms = {
  instant_ink: 'Instant Ink',
  standard: 'Standard',
  hp_plus: 'HP+',
  gen2_standard: 'Gen2 Standard',
  ai_enabled: 'AI-Enabled'
}

export const ContentStackExperiences = {
  hp_smart: 'HPSmart',
  hpx: 'HPX'
}

// HP branding
export const PORTAL_BRAND = {
  HP_SMART_ADMIN: 'HP Smart Admin',
  HP_CONTROL_HUB: 'HP Control Hub'
}

export const SETUP_APP_BRANDING = {
  HP_SMART: 'HP Smart',
  HPX: 'HP'
}

export const HPX_MIN_TABLET_WIDTH = 768

export const RETRYABLE_ERRORS_RULES = [
  { regex: /^UA_.*/, retryable: true },
  { regex: /FW_DHP00002/, retryable: true },
  { code: 'UA_400_EB000U0422', retryable: false },
  { code: 'UA_400_EB000A0022', retryable: false },
  { code: VALIDATE_DEVICE_TIMEOUT_ERROR, retryable: true },
  { code: REGISTER_DEVICE_INVALID_DATA_ERROR, retryable: true },
  { code: VALIDATE_RTP_TIMEOUT_ERROR, retryable: true }
]

// Silent retry configuration
export const SILENT_RETRY_MAX_ATTEMPTS = 3
export const SILENT_RETRY_DELAY_MS = DELAY_2_SEC
export const SILENT_RETRY_REGISTER_ERROR_CODES = ['E0044A0076']
export const SILENT_RETRY_DHP_ERROR_TYPES = [
  'unknownError',
  'deviceOffline',
  'requestTimedOut'
]

export const DEVICE_CLAIM_EVENT_NAME = 'DeviceClaim'
